const iconsMapping = new Map([
	//['imagename-no-extention', ['FontAwesome name',     'class']],
	['warning_small',            ['exclamation-triangle', ]],
	['info_grey',                ['info-circle',          ]],
	['folder_go',                ['folder-open',          ]],
	['page_save',                ['file-download',        ]],
	['page',                     ['file',                 ]],
	['printer',                  ['print',                ]],
	['file_pdf',                 ['file-pdf',             ]],
	['cross',                    ['times-circle',         ]],
	['tick',                     ['check-circle',         ]],
	['cross_disabled',           ['times-circle',         'disabled']],
	['tick_disabled',            ['check-circle',         'disabled']],
	['flag_green',               ['flag',                 'green']],
	['flag_pink',                ['flag',                 'pink']],
	['flag_orange',              ['flag',                 'orange']],
	['flag_purple',              ['flag',                 'purple']],
	['flag_yellow',              ['flag',                 'yellow']],
	['flag_red',                 ['flag',                 'red']],
	['flag_blue',                ['flag',                 'blue']],
	['delete_disabled',          ['trash-alt',            'disabled']],
	['folder',                   ['folder',               ]],
	['page_add',                 ['plus',                 ]],
	['page_edit',                ['edit',                 ]],
	['view',                     ['eye',                  ]],
	['delete',                   ['trash-alt',            ]],
	['user_go',                  ['user',                 ]],
	['group_edit',               ['edit',                 ]],
	['user_edit',                ['edit',                 ]],
	['file_doc',                 ['file-word',            ]],
	['warning',                  ['exclamation-triangle', ]],
	['magnifier',                ['search',               ]],
	['add',                      ['plus',                 ]],
	['group_add',                ['plus',                 ]],
	['user_add',                 ['plus',                 ]],
	['accept',                   ['check-circle',         ]],
	['arrow_refresh',            ['sync',                 ]],
	['arrow_rotate_clockwise',   ['redo',                 ]],
	['bullet_green',             ['circle-small',         'green']],
	['bullet_red',               ['circle-small',         'red']],
	['bullet_yellow',            ['circle-small',         'yellow']],
	['bullet_white',             ['circle-small',         'gray']],
	['bullet_toggle_minus',      ['minus-circle',         ]],
	['bullet_toggle_plus',       ['plus',                 ]],
	['chart_bar',                ['chart-bar',            ]],
	['chart_curve',              ['chart-line',           ]],
	['chart_pie',                ['chart-pie',            ]],
	['clipboard',                ['clipboard',            ]],
	['control_play_blue',        ['play-circle',          'blue']],
	['control_play',             ['play-circle',          ]],
	['control_stop_blue',        ['stop-circle',          'blue']],
	['control_stop',             ['stop-circle',          ]],
	['disk',                     ['save',                 ]],
	['downward',                 ['caret-down',           ]],
	['email_add',                ['plus',                 ]],
	['email_go',                 ['paper-plane',          ]],
	['file_doc',                 ['file-word',            ]],
	['file_docx',                ['file-word',            ]],
	['file_gif',                 ['file-image',           ]],
	['file_jpg',                 ['file-image',           ]],
	['file_pdf',                 ['file-pdf',             ]],
	['file_png',                 ['file-image',           ]],
	['file_ppt',                 ['file-powerpoint',      ]],
	['file_txt',                 ['file-lines',           ]],
	['file_unknown',             ['file',                 ]],
	['file_xls',                 ['file-spreadsheet',     ]],
	['file_xlsx',                ['file-spreadsheet',     ]],
	['folder_explore',           ['search',               ]],
	['group_key',                ['key',                  ]],
	['hourglass',                ['hourglass',            ]],
	['image_edit',               ['edit',                 ]],
	['info',                     ['info-circle',          ]],
	['link_break',               ['unlink',               ]],
	['link_delete',              ['trash-alt',            ]],
	['link_go',                  ['check-circle',         ]],
	['link',                     ['link',                 ]],
	['lock',                     ['lock',                 ]],
	['move',                     ['arrows',               ]],
	['order_white_asc',          ['chevron-up',           ]],
	['order_white_desc',         ['chevron-down',         ]],
	['package_add',              ['plus',                 ]],
	['package_go',               ['shipping-fast',        ]],
	['page_delete',              ['trash-alt',            ]],
	['picture_edit',             ['edit',                 ]],
	['picture_go',               ['check-circle',         ]],
	['resultset_first',          ['step-backward',        ]],
	['resultset_last',           ['step-forward',         ]],
	['resultset_next_multi',     ['forward',              ]],
	['resultset_next',           ['play',                 ]],
	['resultset_previous_multi', ['backward',             ]],
	['resultset_previous',       ['backward-step',        ]],
	['table_delete',             ['trash',                ]],
	['table_go',                 ['check-circle',         ]],
	['table_save',               ['save',                 ]],
	['time_add',                 ['plus',                 ]],
	['time_go',                  ['check-circle',         ]],
	['time',                     ['clock',                ]],
	['upward',                   ['caret-up',             ]],
]);

function replaceIcon($img) {
	let imgpath   = $img.attr('src');
	let lastSlash = imgpath.lastIndexOf('/');
	let imgfile   = imgpath.substring(lastSlash + 1);
	let filename  = imgfile.split('.')[0];
	
	if (iconsMapping.has(filename)) {
		let replacement = iconsMapping.get(filename);
		let icon        = replacement[0];
		let iconClass   = replacement[1] || '';
		let $icon       = $('<i class="fa fa-' + (icon + ' ' + iconClass).trim() + '">');

		$icon.attr('title', $img.attr('title'));
		$img.wrap($icon);
		$img.remove();

	} else {
		console.warn('no icon found for', filename);
	}
}

function replaceIcons($images) {
	$images.filter('[src*="assets/img/icons/"]').each(function() {
		replaceIcon($(this));
	});

	$images.filter('[src*="/admin_assets/icons/"]').each(function() {
		replaceIcon($(this));
	});

	$images.filter('[src*="assets/img/warning"]').each(function() {
		replaceIcon($(this));
	});
}

const iconObserver = new MutationObserver(function(mutationsList, observer) {
	for (const mutation of mutationsList) {
		for (const node of mutation.addedNodes) {
			var $images = $(node).filter('img');
			if ($images.length === 0) $images = $(node).find('img');
			if ($images.length) replaceIcons($images);
		}
	}
});

iconObserver.observe(document, {childList: true, subtree: true});

$(function() {
	replaceIcons($('img'));
});

